module.exports = __webpack_public_path__ + "static/media/up-arrow-black.18915cc1.svg";